export default __webpack_public_path__ + "logo-talaris-c66e4f3d5214941b362e346f33cdac7c.svg";